import { invoke } from '@tauri-apps/api/core';

/** Store entries are enabled only after the operator has published their own apps. */
export function nativeUpdateLink(
  platform: 'ios' | 'android'
): string | undefined {
  const configured =
    platform === 'android'
      ? import.meta.env.VITE_ATLAS_ANDROID_STORE_URL
      : import.meta.env.VITE_ATLAS_IOS_STORE_URL;
  if (!configured) return undefined;
  try {
    const url = new URL(configured);
    if (url.protocol !== 'https:' || url.username || url.password)
      return undefined;
    if (platform === 'android') {
      if (
        url.hostname !== 'play.google.com' ||
        url.pathname !== '/store/apps/details' ||
        url.searchParams.get('id') !== 'de.solidum.atlas'
      )
        return undefined;
    } else if (
      url.hostname !== 'apps.apple.com' ||
      !/\/id[0-9]+$/.test(url.pathname)
    )
      return undefined;
    return url.href;
  } catch {
    return undefined;
  }
}

/** Keep the current app usable when the operating system cannot open the link. */
export async function openNativeUpdateLink(
  platform: 'ios' | 'android'
): Promise<boolean> {
  const url = nativeUpdateLink(platform);
  if (!url) return false;
  try {
    await invoke('plugin:opener|open_url', { url });
    return true;
  } catch (error) {
    console.error('[native-update] unable to open store', error);
    return false;
  }
}
